// this provides the static navigation structure
import type { StaticNavigationItem } from '../types/staticNavigation';

export const StaticNavigation: StaticNavigationItem[] = [
    {
        snippet: 'shop',
        url: '/',
        children: null,
    },
    {
        snippet: 'vendor.name',
        url: null,
        children: [
            {
                snippet: 'vendor.directory.name',
                url: 'https://ids.online/dental-hersteller-verzeichnis',
                children: [
                    {
                        snippet: 'vendor.directory.dentalArea',
                        url: 'https://ids.online/dental-hersteller-verzeichnis?category1=zahnmedizin',
                        children: null,
                    },
                    {
                        snippet: 'vendor.directory.dentalTechnicianArea',
                        url: 'https://ids.online/dental-hersteller-verzeichnis?category1=zahntechnik',
                        children: null,
                    },
                    {
                        snippet: 'vendor.directory.infectionProtection',
                        url: 'https://ids.online/dental-hersteller-verzeichnis?category1=infektionsschutz',
                        children: null,
                    },
                    {
                        snippet: 'vendor.directory.services',
                        url: 'https://ids.online/dental-hersteller-verzeichnis?category1=dienstleistungen-edv',
                        children: null,
                    },
                ],
            },
        ],
    },
    {
        snippet: 'news',
        url: 'https://ids.online/dental-news',
        children: null,
    },
    {
        snippet: 'education',
        url: 'https://ids.online/education',
        children: null,
    },
    {
        snippet: 'aboutUs.name',
        url: null,
        children: [
            {
                snippet: 'aboutUs.directory.name',
                url: 'https://ids.online/ueber-uns',
                children: [
                    {
                        snippet: 'aboutUs.directory.productData',
                        url: 'https://ids.online/services?tab=product-data-hub-pdh',
                        children: null,
                    },
                    {
                        snippet: 'aboutUs.directory.oderProcessing',
                        url: 'https://ids.online/services?tab=Order-Process-Hub',
                        children: null,
                    },
                    {
                        snippet: 'aboutUs.directory.vendorDirectory',
                        url: 'https://ids.online/services/anbieterverzeichnis',
                        children: null,
                    },
                    {
                        snippet: 'aboutUs.directory.showrooms',
                        url: 'https://ids.online/services?tab=virtuelle-showrooms',
                        children: null,
                    },
                    {
                        snippet: 'aboutUs.directory.jobs',
                        url: 'https://ids.online/services/jobportal',
                        children: null,
                    },
                    {
                        snippet: 'aboutUs.directory.digitalBag',
                        url: 'https://ids.online/services/digitaler-messebeutel',
                        children: null,
                    },
                ],
            },
        ],
    },
];
